import { Card, CardContent, Grid, Typography } from '@mui/material';
import React from 'react';
import { makeStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import palette from '../theme/palette';

const useStyles = makeStyles({
  titleText: {
    textTransform: 'uppercase',
    fontSize: 12,
    color: palette.grey[500]
  },
  subText: {
    fontSize: 19,
    marginTop: 10
  }
});

export default function MarkingSchema({ correctAns, incorrectAns }) {
  const classes = useStyles();
  return (
    <Card style={{ marginTop: 15 }}>
      <CardContent>
        <Typography variant="subtitle1">Marking Scheme</Typography>
        <Grid container style={{ textAlign: 'center', marginTop: 15 }}>
          <Grid item sm={6} xs={12}>
            <p className={classes.titleText}>CORRECT ANS</p>
            <p className={classes.subText} style={{ color: 'green' }}>
              {correctAns}
            </p>
          </Grid>
          <Grid item sm={6} xs={12}>
            <p className={classes.titleText}>INCORRECT ANS</p>
            <p className={classes.subText} style={{ color: 'red' }}>
              {incorrectAns}
            </p>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}

MarkingSchema.propTypes = {
  correctAns: PropTypes.string,
  incorrectAns: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
